var countdownTimer = document.querySelector('.js-countdown-timer')
var countdownBanner = document.querySelector('.conuntdown-section-wrapper')
function countdownBannerTimer() {
 if (!!countdownTimer) {
    // Set the date we're counting down to
    var countDownDate = new Date(countdownTimer.getAttribute("data-date"));
    // Update the count down every 1 second
    var x = setInterval(function () {
        if(!!countDownDate){
            // Find the distance between now and the count down date
            var distance = Date.parse(countDownDate) - Date.parse(new Date());
            // Time calculations for days, hours, minutes and seconds
            var seconds = Math.floor( (distance / 1000) % 60 );
            var minutes = Math.floor( (distance / 1000 / 60) % 60 );
            var hours = Math.floor( (distance / (1000 * 60 * 60)) % 24 );
            var days = Math.floor( distance / (1000 * 60 * 60 * 24) );

            if(days < 1 ){
                days = '00'
            }

            if(hours <= 0 ){
                hours = '00'
            }else if(hours < 10){
                hours = '0' + hours
            }

            if(minutes <= 0 ){
                minutes = '00'
            }else if(minutes < 10 ){
                minutes = '0' + minutes
            }

            if(seconds < 10 ){
                seconds = '0' + seconds
            }else if(seconds <= 0 ){
                seconds = '00'
            } 
            // Display the result in the element with id="demo"
            countdownTimer.innerHTML=(
                `<span>
                    ${days}${languages.days}
                    ${hours}${languages.hours}
                    ${minutes}${languages.minutes}
                    ${seconds}${languages.seconds}
                </span>`
            );
            // If the count down is finished, write some text 
            if (distance < 0) {
                clearInterval(x);
                countdownBanner.style.opacity = 0;
                setTimeout(function () {
                    countdownBanner.classList.add('hidden')
                }, 500);
            }
        }
    }, 1000);
  }
}  


document.addEventListener('DOMContentLoaded', function () {
    countdownBannerTimer()
});